"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimeStringFromDate = exports.getPlatformStringFromDate = exports.areRangeBoundsCrossed = exports.mergeDayPickerProps = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var moment_1 = tslib_1.__importDefault(require("moment"));
var Platform_1 = require("../constants/Platform");
var mergeModifiers = function (defaultModifiers, userModifiers) {
    return defaultModifiers ? { modifiers: tslib_1.__assign(tslib_1.__assign({}, defaultModifiers), userModifiers) } : undefined;
};
var mergeDayPickerPropsBody = function (defaultProps, userProps) { return (tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, defaultProps), userProps), mergeModifiers(defaultProps.modifiers, userProps.modifiers))); };
exports.mergeDayPickerProps = function (defaultProps, userProps) { return (userProps ? mergeDayPickerPropsBody(defaultProps, userProps) : defaultProps); };
exports.areRangeBoundsCrossed = function (from, to) {
    return from && to ? moment_1.default(from).isAfter(moment_1.default(to)) : false;
};
exports.getPlatformStringFromDate = function (value) { return moment_1.default(value).format(Platform_1.platformDateFormat); };
exports.getTimeStringFromDate = function (value) { return moment_1.default(value).format(Platform_1.TIME_FORMAT); };
//# sourceMappingURL=utils.js.map